import { Component, Input, OnInit } from '@angular/core';

import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-lex-icon-button',
  templateUrl: './lex-icon-button.component.html',
  styleUrls: ['./lex-icon-button.component.scss'],
  standalone: false,
})
export class LexIconButtonComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @Input() color = 'blue';
  @Input() buttonClass = '';
  @Input() disabled: boolean;
  @Input() matIcon: string;
  @Input() svgIcon: string;
  @Input() tooltip: string;

  constructor() {}

  ngOnInit() {}
}
